import RequiredField from "./RequiredField";
import BopCategory from "./BopCategory";

export default class QuotationResult {

    constructor(jsonResponse) {

        if (jsonResponse) {
            this.quotationReference = jsonResponse["quotation-reference"];
            this.vat = jsonResponse["vat"];
            this.total = jsonResponse["total"];
            this.fees = jsonResponse["fees"];
            this.destinationAmount = jsonResponse["destination-amount"];
            this.destinationCurrency = jsonResponse["destination-currency"];
            this.effectiveRate = jsonResponse["effective-rate"];
            this.bopCategory = jsonResponse["bop-category"] ? new BopCategory(jsonResponse["bop-category"]) : "";

            this.requiredFields = [];

            let jsonRequiredFields = jsonResponse["required-fields"] || [];

            jsonRequiredFields.forEach(requiredField => {
                this.requiredFields.push(new RequiredField(requiredField));
            });
        }
    }


}
